import { render, staticRenderFns } from "./NettoDiffTable.vue?vue&type=template&id=05e8a7c2"
import script from "./NettoDiffTable.vue?vue&type=script&lang=js"
export * from "./NettoDiffTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports